import React from 'react';

import Slug from '../../components/Slug';
import type { BulkContactImportResponse } from '../../api';

type ResultPanelProps = {
  result: BulkContactImportResponse;
};

const StatItem: React.FC<{
  label: string;
  value: number;
  color?: SlugColorType;
}> = ({ label, value, color = 'gray' }) => (
  <div className="flex flex-col items-center gap-y-xs">
    <span className="text-2xl font-bold text-text">{value}</span>
    <Slug text={label} color={color} />
  </div>
);

const ResultPanel: React.FC<ResultPanelProps> = ({ result }) => {
  return (
    <section className="flex flex-col gap-y-md border border-active rounded-sm p-xl bg-content">
      <h3 className="text-base font-semibold text-text">Import Results</h3>

      <div className="flex flex-row flex-wrap gap-xl">
        <StatItem label="Total" value={result.total} />
        <StatItem label="Created" value={result.created} color="success" />
        <StatItem label="Updated" value={result.updated} color="main" />
        <StatItem label="Skipped" value={result.skipped} color="warning" />
        <StatItem label="Errors" value={result.errors.length} color="danger" />
      </div>

      {!!result.errors.length && (
        <div className="flex flex-col gap-y-xs mt-md">
          <span className="text-small font-medium text-text">Errors:</span>
          <ul className="list-disc pl-xl text-small text-text">
            {result.errors.map((err, i) => (
              <li key={i} className="text-danger">
                {err}
              </li>
            ))}
          </ul>
        </div>
      )}

      {!!result.contact_ids.length && (
        <div className="flex flex-col gap-y-xs mt-md">
          <span className="text-small font-medium text-text">
            Contact IDs ({result.contact_ids.length}):
          </span>
          <div className="text-tiny text-textLight break-all max-h-[10rem] overflow-y-auto bg-bg p-md rounded-sm border border-active">
            {result.contact_ids.join(', ')}
          </div>
        </div>
      )}
    </section>
  );
};

export default React.memo(ResultPanel);
